// Constants
import { FILE_EXTENSION_VALIDATION_OPTIONS } from '../Constants/Constants';

export const ValidateFileSize = (file: File | null) => {
    if (file) {
        const fileSize: number = file.size / 1024 / 1024;
        return fileSize <= 10;
    }

    return false;
};

export const ValidateFileExtension = (file: File | null) => {
    if (file) {
        const allowedFileTypes: string[] = FILE_EXTENSION_VALIDATION_OPTIONS;
        const fileExtension: string = file.name.substring(
            file.name.lastIndexOf('.') + 1,
            file.name.length
        );

        return allowedFileTypes.includes(fileExtension);
    }
    return false;
};